import { render, staticRenderFns } from "./DocumentEmail.component.pug?vue&type=template&id=10268b80&scoped=true&lang=pug&"
import script from "./DocumentEmail.component.ts?vue&type=script&lang=ts&"
export * from "./DocumentEmail.component.ts?vue&type=script&lang=ts&"
import style0 from "./DocumentEmail.component.scss?vue&type=style&index=0&id=10268b80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10268b80",
  null
  
)

export default component.exports